var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: {
          id: "hamburger-container",
          "is-active": _vm.sidebar.opened,
          disabled: "true"
        },
        on: { toggleClick: _vm.toggleSideBar }
      }),
      _vm._v(" "),
      _c("breadcrumb", {
        staticClass: "breadcrumb-container",
        attrs: { id: "breadcrumb-container" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          [
            _c(
              "el-tooltip",
              {
                attrs: {
                  content: _vm.$t("navbar.refreshCache"),
                  effect: "dark",
                  placement: "bottom"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "refresh-icon right-menu-item hover-effect",
                    staticStyle: { "padding-top": "1px" },
                    on: { click: _vm.refreshCache }
                  },
                  [_c("span", [_c("i", { staticClass: "fas fa-sync" })])]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-tooltip",
              {
                attrs: {
                  content: _vm.isFullscreen
                    ? _vm.$t("navbar.exitFullScreen")
                    : _vm.$t("navbar.enterFullScreen"),
                  effect: "dark",
                  placement: "bottom"
                }
              },
              [
                _c("screenfull", {
                  staticClass: "right-menu-item hover-effect",
                  attrs: { id: "screenfull" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-tooltip",
              {
                attrs: {
                  content: _vm.$t("navbar.size"),
                  effect: "dark",
                  placement: "bottom"
                }
              },
              [
                _c("size-select", {
                  staticClass: "right-menu-item hover-effect",
                  attrs: { id: "size-select" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-tooltip",
              {
                attrs: {
                  content: _vm.$t("navbar.switchLanguage"),
                  effect: "dark",
                  placement: "bottom"
                }
              },
              [
                _c("lang-select", {
                  staticClass: "right-menu-item hover-effect"
                })
              ],
              1
            )
          ],
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "hover" }
            },
            [
              _c(
                "div",
                { staticClass: "avatar-wrapper" },
                [
                  _c("svg-icon", { attrs: { "icon-class": "person" } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "username-label" }, [
                    _vm._v(_vm._s(_vm.$store.getters.name))
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "el-icon-caret-bottom" })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/" } },
                    [
                      _c("el-dropdown-item", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("navbar.dashboard")) +
                            "\n          "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { on: { click: _vm.logout } },
                    [
                      _c("el-dropdown-item", { attrs: { divided: "" } }, [
                        _c("span", { staticStyle: { display: "block" } }, [
                          _vm._v(_vm._s(_vm.$t("navbar.logOut")))
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }